const agentRoles = ['agent'];
const memberRoles = ['member', 'group_member'];

export default context => {
  if (memberRoles.includes(context)) {
    return { type: context, dependency1: 'group_id' };
  }
  if (agentRoles.includes(context)) {
    return {
      type: context,
      dependency1: 'project_id',
      dependency2: 'organization_id',
    };
  }
  return { type: context, dependency1: 'organization_id' };
};
